import Range from '@/modules/common/components/form/range'

export class OrderStatementFilter {
  range?: Range | null = null
  paymentTypeId: number | null = null
  query: string | null = null
}
